// src/pages/Team.jsx
import { motion } from 'framer-motion';
import Images from '../Images';

const Team = () => {
  const teamMembers = [
    { name: "Prince Bruce Otoo", role: "Director Of Operations", image: Images.PrinceBruceOtoo },
    { name: "George Bruce Otoo", role: "Head of Content ", image: Images.GeorgeBruceOtoo },
    { name: "Juliana Agyeiwaa Asare", role: "Customer Support Manager", image: Images.JulianaAgyeiwaaAsare },
    { name: "Daniel Avorwulanu", role: "Account Manager", image: Images.DanielAvorwulanu },
    {name:"Eugene Opoku Asante",role:"Product Manager",image:Images.EugeneOpokuAsante},
  ];

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <div className="pt-32 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-brand-cream to-orange-50 py-20">
        <div className="max-w-8xl mx-auto px-6 lg:px-16 text-center">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-brand-orange text-sm font-semibold tracking-wider"
          >
            OUR TEAM
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-5xl font-bold text-gray-900 mt-4 mb-6"
          >
            Dedicated experts, working for you
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-xl text-gray-600 max-w-3xl mx-auto"
          >
            Behind every successful renowned organisation is a team of professionals committed 
            to guiding you with trust, expertise, and care.
          </motion.p>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-16">
        <div className="max-w-8xl mx-auto px-6 lg:px-16">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: {
                opacity: 1,
                transition: { staggerChildren: 0.05 }
              }
            }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
          >
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                variants={fadeUp}
                whileHover={{ y: -8, transition: { duration: 0.3 } }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className="aspect-[3/4] bg-gradient-to-br from-brand-blue to-brand-navy">
                  <img 
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900">{member.name}</h3>
                  <p className="text-gray-600 text-sm mt-1">{member.role}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Team;